import React, { useState } from 'react';
import './ScrollHeader.css';

const ScrollHeader = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  const smoothScroll = (e) => {
    e.preventDefault();
    const id = e.currentTarget.getAttribute('href').slice(1);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const smoothScrollMobile = (e) => {
    smoothScroll(e);
    closeMenu();
  };

  return (
    <div className="scroll-header">
      <div className="scroll-title">ZACH BILES</div>
      <nav className="scroll-nav">
        <a href="#about" onClick={smoothScroll}>About</a>
        <a href="#resumexrays" onClick={smoothScroll}>ResumeXRays</a>
        <a href="#resume" onClick={smoothScroll}>Experience</a>
        <a href="#contact" onClick={smoothScroll}>Contact</a>
      </nav>

      <button
        className={`scroll-hamburger ${menuOpen ? 'open' : ''}`}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle menu"
      >
        <span />
        <span />
        <span />
      </button>

      <div
        className={`scroll-mobile-overlay ${menuOpen ? 'open' : ''}`}
        onClick={(e) => e.target === e.currentTarget && closeMenu()}
      >
        <nav className="scroll-mobile-nav">
          <a href="#about" onClick={smoothScrollMobile}>About</a>
          <a href="#resumexrays" onClick={smoothScrollMobile}>ResumeXRays</a>
          <a href="#resume" onClick={smoothScrollMobile}>Experience</a>
          <a href="#contact" onClick={smoothScrollMobile}>Contact</a>
        </nav>
      </div>
    </div>
  );
};

export default ScrollHeader;
